import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';
import Panel from '../../../components/Panel/Panel';
import { sliderToRealValueCoefficient } from '../../../utils/helpers';
import InsightsDashboardSlider
  from '../../MaterialAssessmentPages/MaterialAssessmentInsightsDashboard/components/InsightsDashboardSlider';

import type { ISettingWeightingProps } from './interfaces/ISettingWeightingProps';

import styles from './scss/SettingWeighting.module.scss';

function SettingWeightingView({
  control,
  coefficientData,
  fields,
  update,
  onSaveCoefficients,
  isSetImpactLoading,
  isBackModalOpen,
  setIsBackModalOpen,
  onHandleBackConfirm,
}: ISettingWeightingProps) {
  const { t } = useTranslation();

  return (
    <>
      <Panel className={styles.root}>
        <div className={styles.titleWrapper}>
          <p>{t('materialityAssessment.settingWeighting')}</p>
        </div>
        <div className={styles.rootContainer}>
          <InsightsDashboardSlider
            control={control}
            coefficientData={coefficientData}
            fields={fields}
            onSliderChange={(index, val, field, sliderField) => {
              const real = val === -10 ? 0.1 : sliderToRealValueCoefficient(+val);
              sliderField.onChange(real);
              update(index, { id: field.id, impact: real });
            }}
          />
          <div className={styles.buttonWrapper}>
            <Button
              title={t('common.save')}
              className={styles.button}
              isLoading={isSetImpactLoading}
              onClick={onSaveCoefficients}
            />
          </div>
        </div>
      </Panel>
      <Modal
        open={isBackModalOpen}
        title={t('createNewUser.cancelModalTitle')}
        description={t('clients.cancelModalText')}
        confirmTitle={t('common.discardChanges')}
        closeTitle={t('common.keepEditing')}
        confirmVariant="error"
        onClose={() => setIsBackModalOpen(false)}
        onReject={() => setIsBackModalOpen(false)}
        onConfirm={onHandleBackConfirm}
      />
    </>
  );
}

export default SettingWeightingView;
